angular.module('bmsApp.trugreen.inventory').controller('TGInventoryMainCtrl',
	function ($state,
			  $scope) {

		$scope.$on("InventoryIndexSideData", function (e, inventoryData) {
			$scope.inventoryData = inventoryData;
		});
	});